import { RefObject } from "react";
import { useForm } from "react-hook-form";
import { useQueryClient } from "@tanstack/react-query";
import { zodResolver } from "@hookform/resolvers/zod";
import { useNotification, useTranslate } from "@refinedev/core";

import { ModalRef } from "@shared/components";
import { listPrescribersQueryKey } from "@modules/prescribers/services/queries";
import { useCreatePrescriberMutation } from "@modules/prescribers/services/mutations";
import { PrescriberFormValues, prescriberSchema } from "@modules/prescribers/validations";
import { CreatePrescriberModalProps } from "./types";

export function useCreatePrescriberModal({ modalRef, onComplete }: CreatePrescriberModalProps) {
  const queryClient = useQueryClient();
  const translate = useTranslate();
  const { open } = useNotification();

  const methods = useForm<PrescriberFormValues>({
    resolver: zodResolver(prescriberSchema()),
    mode: "onBlur",
  });

  const { mutateAsync, isPending } = useCreatePrescriberMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: listPrescribersQueryKey,
        refetchType: 'all',
      });

      open?.({
        type: "success",
        message: translate("prescriber_admin.success.create"),
      });

      onComplete();
      modalRef.current?.close();
    },
  });


  return {
    methods,
    mutateAsync,
    isPending,
  };
}
